/**
 * @generated SignedSource<<857af7b6e43e29ea4e29292f350aec10>>
 * @relayHash 902035768e588acb4affaf8b9ad79cde
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID bc54d3f8868f1f08b1400903f08eba41397e00e0be698e1b1c6d08a9762a3b9e

import type { ConcreteRequest } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type RestoreDefaultsTextButtonResetSpaceContentStatesMutation$variables = {
  spaceKey: string;
};
export type RestoreDefaultsTextButtonResetSpaceContentStatesMutation$data = {
  readonly resetSpaceContentStates: {
    readonly contentStatesAllowed: boolean | null | undefined;
    readonly customContentStatesAllowed: boolean | null | undefined;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined> | null | undefined;
    readonly spaceContentStatesAllowed: boolean | null | undefined;
  } | null | undefined;
};
export type RestoreDefaultsTextButtonResetSpaceContentStatesMutation = {
  response: RestoreDefaultsTextButtonResetSpaceContentStatesMutation$data;
  variables: RestoreDefaultsTextButtonResetSpaceContentStatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceKey"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
      }
    ],
    "concreteType": "ContentStateSettings",
    "kind": "LinkedField",
    "name": "resetSpaceContentStates",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "contentStatesAllowed"
      },
      {
        "kind": "ScalarField",
        "name": "spaceContentStatesAllowed"
      },
      {
        "kind": "ScalarField",
        "name": "customContentStatesAllowed"
      },
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "spaceContentStates",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "name"
          },
          {
            "kind": "ScalarField",
            "name": "color"
          },
          {
            "kind": "ScalarField",
            "name": "id"
          },
          {
            "kind": "ScalarField",
            "name": "restrictionLevel"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "902035768e588acb4affaf8b9ad79cde",
    "id": "bc54d3f8868f1f08b1400903f08eba41397e00e0be698e1b1c6d08a9762a3b9e",
    "metadata": {},
    "name": "RestoreDefaultsTextButtonResetSpaceContentStatesMutation",
    "operationKind": "mutation",
    "text": "mutation RestoreDefaultsTextButtonResetSpaceContentStatesMutation($spaceKey:String!){resetSpaceContentStates(spaceKey:$spaceKey){contentStatesAllowed,spaceContentStatesAllowed,customContentStatesAllowed,spaceContentStates{name,color,id,restrictionLevel}}}"
  }
};
})();

(node as any).hash = "7681abf1946dae8411518bf0ff51e43d";

export default node;
